import { NgModule } from "@angular/core";

import { DashboardButtonComponent } from "skInsights/partials/buttons/dashboardButton.component";
import { SharedModule } from "skInsights/shared.module";

@NgModule({
    imports: [
        SharedModule,
    ],
    declarations: [
        DashboardButtonComponent,
    ],
    exports: [
        DashboardButtonComponent,
    ],
})
export class ButtonsModule { }
